interface BirthDateEntry {
    userId: string,
    date: string,
}


/**
 * Houses the birthDates of the users that the birthday dialog needs to be opened for on their birthday.
 */
class BirthDates {

    static readonly sepehrSaebnia: BirthDateEntry = {
        userId: '67e34022-cdc6-4c4e-ad9e-6776dc8e60fc',
        date: '1979-08-26',
    }

    static readonly bizkeyTech: BirthDateEntry = {
        userId: '2ad74e5a-7251-4557-b9ef-8539271f4bc5',
        date: '2019-09-01',
    }

    /**
     * Fetches the birthdate of the user associated with the given userId.
     * @param {string} userId
     */
    static getBirthDate(userId?: string): string | undefined {
        switch (userId) {
            case this.sepehrSaebnia.userId:
                return this.sepehrSaebnia.date;
            case this.bizkeyTech.userId:
                return this.bizkeyTech.date;
            default:
                return undefined;
        }
    }
}

export default BirthDates;
